import { uniq, flatten } from "lodash";
export class ExpHelper {
  static uniqFlatten<T>(a: T[][]) {
    return uniq(flatten(a));
  }
}
